import PropTypes from 'prop-types';

export const BookToTaxDifferencePropType = PropTypes.shape({
  exceptionId: PropTypes.number,
  enabledFlag: PropTypes.string,
  exceptionAccount: PropTypes.string,
  description: PropTypes.string,
  exceptionBasis: PropTypes.string,
  disallowedPercentage: PropTypes.number,
  tagDescription: PropTypes.string,
  connections: PropTypes.arrayOf(PropTypes.string),
  excludeCompanyCodes: PropTypes.arrayOf(PropTypes.string),
  countryTaxTypes: PropTypes.arrayOf(PropTypes.string),
});

export const CountryTaxTypePropType = PropTypes.shape({
  countryTaxType: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
});

export const BookToTaxCodeDescriptionPropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});
